import React, { useState } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import AppRouter from './Routes/AppRouter';
import { AuthProvider } from './Context/AuthContext';
import MainLayout from './Components/Layouts/MainLayout/MainLayout';
import LoginPage from './Pages/LoginPage/LoginPage';
import useAuth from './Hooks/useAuth';
import './i18n'; // Import i18n configuration
import { ThemeProvider } from './Context/ThemeContext';
import Terms from './Pages/LoginPage/terms';
import { CartProvider } from './Context/CartProvider';
import { ChatInterface } from './Components/Chatbot/Chatbot';
const AppContent = () => {
  const { user } = useAuth();
  const [chatMessages, setChatMessages] = useState([]);
  const [isChatTyping, setIsChatTyping] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);

  // React.useEffect(() => {
  //     const fetchData = async () => {
  //       try {
  //         const response = await fetch(
  //           "http://api.naf-cloudsystem.de:8080/api/andriod/51654854/advertisements"
  //         );
  //         if (!response.ok) {
  //           throw new Error(`HTTP error! status: ${response.status}`);
  //         }
  //         const data = await response.json();
  //         console.log("Data fetched successfully:", data);
  //       } catch (error) {
  //         console.error("Error fetching data:", error);
  //       }
  //     };

  //     fetchData();
  //   }, []);

  return (
    <Routes>
      {/* Login Page - accessible to unauthenticated users */}
      <Route path="/login" element={!user ? <LoginPage /> : <Navigate to="/" />} />
      <Route path="/privacy" element={<Terms />} />

      {/* Protected Routes - accessible only to authenticated users */}
      <Route
        path="*"
        element={
          user ? (
            <MainLayout>
              <AppRouter />
                 {/* Chatbot - Available on all pages */}
            <ChatInterface 
              messages={chatMessages}
              setMessages={setChatMessages}
              isTyping={isChatTyping}
              setIsTyping={setIsChatTyping}
              isOpen={isChatOpen}
              onClose={() => setIsChatOpen(false)}
              onOpen={() => setIsChatOpen(true)}
            />
            </MainLayout>
          ) : (
            <Navigate to="/login" />
          )
        }
      />
    </Routes>
  );
};

const App = () => {
  return (
    <Router>
      <AuthProvider>
        <ThemeProvider>
          <CartProvider>
            <AppContent />
          </CartProvider>
        </ThemeProvider>
      </AuthProvider>
    </Router>
  );
};

export default App;